import { mediaQueryStyles, constants } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const containerCss = {
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  columnGap: 30,
  rowGap: 15,
  alignItems: "flex-start",
  label: {
    lineHeight: "1rem",
  },
  ">div": {
    width: "100%",
  },
  [breakpoint.downTo("sm")]: {
    flexDirection: "row",
    ">div": {
      maxWidth: "calc((100% / 3) - 20px)",
    },
  },
  ul: {
    zIndex: 1,
    maxWidth: "100%",
    width: "100%",
    textAlign: "left",
    left: 0,
    marginTop: 26,
  },
};

export const saveButtonCss = {
  root: {
    width: "100%",
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      width: "auto",
    },
  },
};

export const submitContainerCss = {
  marginTop: 20,
  display: "flex",
  alignItems: "center",
};

export const savingLoadingCss = {
  root: {
    margin: 0,
    marginLeft: 10,
    width: 30,
    height: 30,
  },
};

export const tooltipDialog = {
  Button: {
    Icon: {
      root: {
        height: 16,
      },
    },
  },
  dialog: {
    Button: {
      Icon: {
        root: {
          width: 15,
        },
      },
    },
  },
};
